var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rows && _vm.rows.length)?_c('div',{staticClass:"chart-overview"},[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"styleClass":"vgt-table"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }